import { render, staticRenderFns } from "./RteManagement.vue?vue&type=template&id=8bdb7df2&"
import script from "./RteManagement.vue?vue&type=script&lang=js&"
export * from "./RteManagement.vue?vue&type=script&lang=js&"
import style0 from "./RteManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports